import { render } from "./WhoHasAccess.vue?vue&type=template&id=5a0204b6&scoped=true&ts=true"
import script from "./WhoHasAccess.vue?vue&type=script&lang=ts"
export * from "./WhoHasAccess.vue?vue&type=script&lang=ts"

import "./WhoHasAccess.vue?vue&type=style&index=0&id=5a0204b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a0204b6"]])

export default __exports__